import {
  CompanyInfoSection,
  CompanyInfoContainer,
  TopInfo,
  LeftSection,
  CompanyLogo,
  CompanyContact,
  ContactNumber,
  BusinessHours,
  PolicyLink,
  CompanyDetails,
  Copyright,
} from "./styles";
import { COMPANY_EMAIL } from "../../../constants/urls";

const CompanyInfo = () => {
  const openPolicyPopup = (policyNumber: number) => {
    window.open(
      `${window.location.origin}/#/policy/${policyNumber}`,
      "_blank",
      "width=800,height=600,scrollbars=yes"
    );
  };

  return (
    <CompanyInfoSection>
      <CompanyInfoContainer>
        <TopInfo>
          <LeftSection>
            <CompanyLogo src="/images/logo_bogun_3x.png" alt="Company Logo" />
            <CompanyContact>
              <ContactNumber>고객센터 070-4138-0788</ContactNumber>
              <BusinessHours>
                평일 7:30~17:30, 점심시간 12:00~13:00
              </BusinessHours>
            </CompanyContact>
          </LeftSection>

          <div style={{ display: "flex", gap: "12px" }}>
            <PolicyLink onClick={() => openPolicyPopup(1)}>이용약관</PolicyLink>
            <PolicyLink onClick={() => openPolicyPopup(2)}>
              개인정보처리방침
            </PolicyLink>
            <PolicyLink onClick={() => openPolicyPopup(3)}>법적고지</PolicyLink>
            <PolicyLink onClick={() => openPolicyPopup(4)}>
              이메일무단수집거부
            </PolicyLink>
          </div>
        </TopInfo>
        <CompanyDetails>
          상호명: 주식회사 브레인다이브 | 대표자: 김창욱 | 전화: 070-4138-0788 |
          팩스: 0504-138-8918 | 이메일: {COMPANY_EMAIL}
          <br />
          사업자등록번호: 527-86-02939 | 개인정보처리책임자: 김창욱 | 주소:
          경기도 남양주시 별내중앙로 26, 5층 504-64
        </CompanyDetails>
        <Copyright>© 브레인다이브. All Rights Reserved.</Copyright>
      </CompanyInfoContainer>
    </CompanyInfoSection>
  );
};

export default CompanyInfo;
